module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0052.png.881ac784.jpg";